import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ad67b28e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrap"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("     至      ");

const _hoisted_3 = {
  style: {
    "float": "right"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_6 = {
  class: "wrap"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("至      ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("重置");

import { computed, ref, watch } from 'vue';
import { getVexTableProps, dateFormat } from '@/config';
import { getIntegralExchangeList, getIntegralIncomeList } from '@/request';
export default {
  name: 'PointTurnoverModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    integralMode: String
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const activeName = ref('income');
    const incomeForm = ref({
      startTime: '',
      endTime: '',
      branchName: '',
      supplierName: ''
    });
    const incomeTable = ref();

    function incomeTableReset() {
      incomeForm.value = {
        startTime: '',
        endTime: '',
        branchName: '',
        supplierName: ''
      };
      incomeTable.value.commitProxy('reload');
    }

    const salesmanPointsColumns = [{
      title: '积分来源',
      field: 'integralSource'
    }, {
      title: '团队名称',
      field: 'supplierName'
    }, {
      title: '发货方',
      field: 'branchName'
    }, {
      title: '客户',
      field: 'custName'
    }, {
      title: '订单编号',
      field: 'orderCode'
    }, {
      title: '订单日期',
      field: 'orderTime'
    }, {
      title: '积分',
      field: 'integralNumber'
    }];
    const platformPointsColumns = [{
      title: '积分来源',
      field: 'integralSource'
    }, {
      title: '积分',
      field: 'integralNumber'
    }, {
      title: '下单业务员',
      field: 'linkMan'
    }, {
      title: '团队名称',
      field: 'supplierName'
    }, {
      title: '发货方',
      field: 'branchName'
    }, {
      title: '客户',
      field: 'custName'
    }, {
      title: '订单编号',
      field: 'orderCode'
    }, {
      title: '订单日期',
      field: 'orderTime'
    }];
    const incomeTableOptions = getVexTableProps({
      columns: props.integralMode === '1' ? salesmanPointsColumns : platformPointsColumns,
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getIntegralIncomeList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              supUserId: props.data.supUserId,
              integralMode: props.integralMode
            }, incomeForm.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.salesmanIntegralIncomeInfoVos
              });
            });
          })
        }
      }
    });
    const expendForm = ref({
      startTime: '',
      endTime: ''
    });
    const expendTable = ref();

    function expendTableReset() {
      expendForm.value = {
        startTime: '',
        endTime: ''
      };
      expendTable.value.commitProxy('reload');
    }

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        incomeTableReset();
        expendTableReset();
      }
    }, {
      flush: 'post'
    });
    const expendTableOptions = getVexTableProps({
      columns: [{
        title: '操作人',
        width: '150px',
        field: 'operator',
        showOverflow: true
      }, {
        title: '操作时间',
        field: 'operationTime',
        showOverflow: true
      }, {
        title: '兑换积分',
        width: '150px',
        field: 'exchangeIntegral',
        showOverflow: true
      }, {
        title: '现有积分',
        field: 'redeemableIntegral',
        width: '150px',
        showOverflow: true
      }],
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getIntegralExchangeList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supUserId: props.data.supUserId,
              integralMode: props.integralMode
            }, expendForm.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.salesmanIntegralExchangeInfoVos
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "积分流水",
        width: "1000px",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(visible) ? visible.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "500px",
          style: {
            "padding": "10px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => activeName.value = $event),
            type: "card",
            class: "tab"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "收入积分",
              name: "income"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
                inline: true
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "操作日期"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                    style: {
                      "width": "250px"
                    },
                    modelValue: incomeForm.value.startTime,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => incomeForm.value.startTime = $event),
                    "value-format": _unref(dateFormat),
                    type: "date"
                  }, null, 8, ["modelValue", "value-format"]), _hoisted_2, _createVNode(_component_el_date_picker, {
                    style: {
                      "width": "250px"
                    },
                    modelValue: incomeForm.value.endTime,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => incomeForm.value.endTime = $event),
                    "value-format": _unref(dateFormat),
                    type: "date"
                  }, null, 8, ["modelValue", "value-format"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "发货方名称"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: incomeForm.value.branchName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => incomeForm.value.branchName = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "团队名称"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: incomeForm.value.supplierName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => incomeForm.value.supplierName = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
                  type: "primary",
                  icon: "Search",
                  onClick: _cache[4] || (_cache[4] = $event => incomeTable.value.commitProxy('reload'))
                }, {
                  default: _withCtx(() => [_hoisted_4]),
                  _: 1
                }), _createVNode(_component_el_button, {
                  type: "primary",
                  icon: "Refresh",
                  onClick: incomeTableReset
                }, {
                  default: _withCtx(() => [_hoisted_5]),
                  _: 1
                })])]),
                _: 1
              })]), _createVNode(_component_vxe_grid, _mergeProps(_unref(incomeTableOptions), {
                ref_key: "incomeTable",
                ref: incomeTable
              }), null, 16)]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "支出积分",
              name: "expend"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, null, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "操作日期"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                    style: {
                      "width": "200px",
                      "margin-right": "20px"
                    },
                    modelValue: expendForm.value.startTime,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => expendForm.value.startTime = $event),
                    "value-format": _unref(dateFormat),
                    type: "date"
                  }, null, 8, ["modelValue", "value-format"]), _hoisted_7, _createVNode(_component_el_date_picker, {
                    style: {
                      "width": "200px",
                      "margin-right": "20px"
                    },
                    modelValue: expendForm.value.endTime,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => expendForm.value.endTime = $event),
                    "value-format": _unref(dateFormat),
                    type: "date"
                  }, null, 8, ["modelValue", "value-format"]), _createVNode(_component_el_button, {
                    type: "primary",
                    icon: "Search",
                    onClick: _cache[7] || (_cache[7] = $event => expendTable.value.commitProxy('reload'))
                  }, {
                    default: _withCtx(() => [_hoisted_8]),
                    _: 1
                  }), _createVNode(_component_el_button, {
                    type: "primary",
                    icon: "Refresh",
                    onClick: expendTableReset
                  }, {
                    default: _withCtx(() => [_hoisted_9]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]), _createVNode(_component_vxe_grid, _mergeProps(_unref(expendTableOptions), {
                ref_key: "expendTable",
                ref: expendTable
              }), null, 16)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};